import jquery from "jquery";
import angular from 'angular';
import Cookies from "js-cookie";
import "@/assets/css/bootstrap.css";
import "@/assets/css/base-theme.css";
import "@/assets/css/main.css";
import "@uirouter/angularjs";
import "angular-ui-bootstrap";
import "angular-ui-bootstrap/dist/ui-bootstrap-tpls";
import "ns-popover";
import "angular-sanitize";
import "ui-select";
import "@services/import";
import "@components/import";
import "@filters/import";
import "@directives/import";
import {WebshopRootScope, AdminUserRole} from "@/models";
import {IAppConfig, registerConfig} from "@/Commons/constants";
import {registerCore} from "@core/import";
import {registerRoutes} from "@/app.routes";
import {registerGuard} from "@/Middlewares/authGuard";
import {registerBaseApiFactory} from "@/Factories/BaseApiFactory";
import {UpdateChecker} from "@core/update-checker";

window['jQuery'] = window['$'] = jquery;
window['angular'] = angular;

const app = angular.module('webshop-admin-app', [
    'ui.bootstrap.tpls',
    'ui.bootstrap',
    'ui.router',
    'nsPopover',
    'ngSanitize',
    'ui.select',
]) as IModule;

registerConfig(app);
registerCore(app)
registerBaseApiFactory(app);
registerRoutes(app);
registerGuard(app);

app.run([
    '$rootScope',
    'APP_CONFIG',
    'AdminUserRole',
    function ($rootScope: WebshopRootScope, appConfig: IAppConfig, roles: typeof AdminUserRole) {
        $rootScope.APP_CONFIG = appConfig;
        $rootScope.AdminUserRole = roles;
        readGlobalSetting($rootScope);
    }
]);

function readGlobalSetting($rootScope) {
    $rootScope.expandedFilter = JSON.parse(localStorage.getItem('expandedFilter') || '{}');
    $rootScope.displayMode = JSON.parse(localStorage.getItem('displayMode') || '{}');
}

console.log('✅ Created webshop-admin');

app.config([
    '$controllerProvider',
    '$compileProvider',
    '$provide',
    '$filterProvider',
    function ($controllerProvider,
              $compileProvider,
              $provide,
              $filterProvider,
    ) {
        app.registerComponent = $compileProvider.component.bind($compileProvider);
        app.registerDirective = $compileProvider.directive.bind($compileProvider);
        app.registerController = $controllerProvider.register.bind($controllerProvider);
        app.registerService = $provide.service.bind($provide);
        app.registerFactory = $provide.factory.bind($provide);
        app.registerFilter = $filterProvider.register.bind($filterProvider);
    }
]);

app.run(
    [
        '$rootScope',
        'APP_CONFIG',
        '$state',
        'StateHelperFactory',
        async function ($rootScope: WebshopRootScope,
                        APP_CONFIG: IAppConfig,
                        $state,
                        stateHelperFactory
        ) {
            $rootScope.apiState = {
                blockApiCount: 0,
                totalApiRunning: 0
            };

            $rootScope['getLangData'] = async (langCode = '') => {
                if (!langCode) {
                    langCode = Cookies.get('lang_code_admin') || $rootScope.selectedLang || 'en';
                }

                const response = await fetch(APP_CONFIG.baseApiUrl + '/v2/api/lang/' + langCode, {
                    method: 'GET',
                });

                const data = await response.json();
                if (!data || !data.IsSuccess) {
                    console.error('Failed to load language data.');
                    return;
                }

                $rootScope.langObj = data.Value;

                if (!$rootScope.$$phase) {
                    $rootScope.$apply();
                }
            }

            $rootScope.translate = function (key, data = null) {
                if ($rootScope.APP_CONFIG.noTranslate || typeof key != "string") {
                    return key;
                }

                key = key.trim().toLowerCase();
                if ($rootScope['langObj']) {
                    return replaceText($rootScope.langObj[key] || key, data);
                }

                return key;
            };

            $rootScope.saveSetting = function (name: keyof WebshopRootScope) {
                if ($rootScope.hasOwnProperty(name) &&
                    typeof $rootScope[name] != 'function' && typeof $rootScope[name] != "undefined")
                    localStorage.setItem(name, JSON.stringify($rootScope[name]));
            };

            $rootScope.logout = () => {
                Cookies.remove('admin_token');
                $rootScope.LoggedInUser = null;
                $state.go(stateHelperFactory.getNameByLink('/Account/Login'));
            }

            $rootScope.setPageTitle = (name: string | null, isText?: boolean, data?: string) => {
                const title = !!name ? (isText ? name : $rootScope.translate(name)) : 'Mascot EPartner Administrator';
                document.title = title + (data ?? '');
            }

            function replaceText(translatedText, data) {
                if (!data) {
                    return translatedText;
                }

                return translatedText.replace(/\{(\w+)\}|\$Model\.(\w+)\$|\$(\w+)\$/g, (match, g1, g2, g3) => {
                    const key = g1 || g2 || g3;
                    return (data[key] !== undefined && data[key] !== null) ? data[key] : match;
                });
            }

            await ($rootScope as any).getLangData();
        }
    ]);

app.run(UpdateChecker);
